import DYNAMIC_REDIRECTS from '~/constants/redirects/dynamicRedirects'
import {
  ANODE,
  CATHODE,
  LITHIUM_ION_BATTERIES,
} from '~/constants/services/constants'

export const getDynamicRoute = (path: string): string | undefined => {
  const route = DYNAMIC_REDIRECTS.find(({ from }) => from.test(path))
  return route?.to
}

export const isMarketPath = (path) => path.startsWith('/market')

export const getMarketRedirect = (path: string, query: string | string[]) => {
  const marketPath = path.replace('/market', '')
  return `${marketPath}/${query}`
}

const REDIRECTS_AUTHENTICATED = {
  sustainability: 'sustainability-index',
}

export const marketWithRedirectInCapacityDatabase = (market?: string) => {
  const MARKETS = {
    [LITHIUM_ION_BATTERIES.alternativeSlug]: 'sodium-ion-capacities',
    [ANODE.slug]: 'sodium-ion-anode',
    [CATHODE.slug]: 'sodium-ion-cathode',
  }

  return MARKETS[market] ?? ''
}

// Helper function to check if a path should be redirected for capacity database
// This makes it easier to test the condition
export const shouldRedirectCapacityDatabase = (
  isAuthenticated: boolean,
  page: string,
  market: string,
  subPage: string,
): boolean => {
  const marketRedirect = marketWithRedirectInCapacityDatabase(market)
  return (
    !isAuthenticated &&
    page === 'capacity-database' &&
    marketRedirect === subPage &&
    marketRedirect !== ''
  )
}

// Helper function to generate the redirect path
// This makes it easier to test the path generation
export const generateCapacityDatabaseRedirectPath = (
  market: string,
  page: string,
): string => {
  return `/${market}/${page}`
}

export const getRedirect = (path: string[], isAuthenticated: boolean) => {
  const market = path[1]
  const page = path[2]
  const subPage = path[3] || ''
  const redirect = REDIRECTS_AUTHENTICATED[page]

  // Use the helper function to check if we should redirect
  if (shouldRedirectCapacityDatabase(isAuthenticated, page, market, subPage)) {
    return generateCapacityDatabaseRedirectPath(market, page)
  }

  // Check if there's no redirect defined for this page
  if (!redirect || redirect === subPage) return undefined

  if (isAuthenticated) {
    return `/${market}/${page}/${redirect}`
  }

  return undefined
}
